<template>
  <div class="navbar" :style="{ width: wrapWidth, marginLeft: `${navWidth}px` }">
    <!-- 左侧隐藏按钮 -->
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <!-- 试用期提醒 -->
    <div class="probation-button">
      <!-- 超管展示 已认证不显示 -->
      <router-link to="/settings/settings_company_manager" v-if="company_info.audit_status !== '2'">
        <el-button plain type="primary" v-if="showTipExpire">
          <span class="text-wrap">
            <i class="el-icon-warning"></i>
            {{
              company_info.left_days > 0 ? $t('1190', { x: company_info && company_info.left_days }) : $t('1197')
            }}</span
          >
          <span class="text-wrap">{{ $t('1196') }}</span>
        </el-button>
      </router-link>
    </div>
    <div class="probation-right">
      <!-- 任务中心 -->
      <el-badge :value="count" :hidden="count === 0" :max="99" class="download-list">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('i18n.16b08507157b425bb2cfe2ba61894af5')"
          placement="bottom-start"
        >
          <img @click="onDownload" src="@/assets/img/icon-list.png" alt="" />
        </el-tooltip>
      </el-badge>
      <!-- 语言包 -->
      <el-dropdown class="language-toggle">
        <div class="language-toggle-son">
          <img src="@/assets/img/icon_map.png" alt="" />
          <span class="el-dropdown-link">{{ curLang.label }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="account-info-dropdown">
          <el-dropdown-item
            class="dropdown-list"
            v-for="(item, index) in langArr"
            :key="index"
            @click.native="changeLanguage(item)"
            >{{ item.label }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 用户身份 -->
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <el-submenu index="1">
          <template slot="title">
            <dl class="user">
              <dt><img class="user-photo" :src="baseInfo.avatar_url || getAvatar(baseInfo.sex || 0)" /></dt>
              <dd>
                <p class="user-name">{{ baseInfo.name }}</p>
                <span class="company-name">{{ company_info.name }}</span>
              </dd>
            </dl>
          </template>
          <el-submenu index="title" class="menu-item menu-list">
            <template slot="title">
              <span><i class="el-icon-sort"></i>{{ $t('navbar_1') }}</span>
            </template>
            <div v-if="companyLength >= 10" class="search__input" style="padding: 10px">
              <el-input
                size="small"
                prefix-icon="el-icon-search"
                :placeholder="$t('i18n.85611ccff8654b479481afcce16b0e88')"
                v-model="companyName"
                @input="handleQueryCompanyByName"
              ></el-input>
            </div>
            <el-menu-item
              v-for="item in companyList"
              :key="item.c_id"
              @click.native="handleCompanyLogin(item)"
              class="menu-item"
              :index="item.c_id"
            >
              <img class="logo_url" :src="item.logo_url ? item.logo_url : icon_company" alt="" />
              {{ item.name }}
              <i v-if="company_info.c_id === item.c_id" class="el-icon-check"></i>
              <template v-if="item.status === 2">
                <el-tag type="warning" size="mini" style="margin-left: 7px">{{
                  $t('i18n.c23be63c319d45d7885074bb6e39e648')
                }}</el-tag>
              </template>
              <template v-if="item.status === 3">
                <el-tag type="danger" size="mini" style="margin-left: 7px">{{
                  $t('i18n.3bba2a086bb64a35b7dfee674b6c6c0d')
                }}</el-tag>
              </template>
            </el-menu-item>
            <el-button class="register" type="text" @click.native="loginCompany">{{ $t('login.30') }}</el-button>
          </el-submenu>
          <el-menu-item index="logout" class="menu-item" @click.native="logout">
            <i class="el-icon-switch-button"></i>{{ $t('300') }}
          </el-menu-item>
          <el-menu-item index="1-3" class="menu-item">
            <span>{{ $t('1209') }}{{ company_info.expire_time }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Hamburger from '@/components/Hamburger'
import { utilCookies } from '@/util/cookies'
import { getAvatar } from '@/util/util'
import { companyLogin } from '@/api/login' // 获取个人信息
import { getPendingTaskCount } from '@/api/payroll'

const icon_company = require('@/assets/img/icon_company.png')

export default {
  props: {
    task: {
      type: Object
    }
  },
  components: {
    Hamburger
  },
  data() {
    return {
      icon_company,
      activeIndex: '',
      language: utilCookies.getLanguage(),
      baseInfo: {},
      companyList: [],
      visible: false,
      count: 0,
      add: 0,
      clearTime: null,
      data: {
        logout: ''
      },
      companyName: '',
      companyLength: 0
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'staffId', 'staffName', 'staffDepartment', 'contractCount', 'avatar']),
    ...mapState({
      company_info: state => state.user.company_info
    }),
    isSa() {
      return this.company_info && this.company_info.is_sa
    },
    showTipExpire() {
      if (this.company_info.left_days <= 7 && this.isSa) return true
      return false
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    langArr() {
      return this.$store.state.settings.langArr
    },
    curLang: {
      get() {
        return this.$store.state.settings.curLang
      },
      set(val) {
        this.$store.commit('settings/updateCurLang', val)
      }
    },
    // 计算宽度
    navWidth() {
      return this.isCollapse ? 48 : 216
    },
    wrapWidth() {
      return `calc(100% - ${this.navWidth}px)`
    }
  },
  created() {
    this.pendingTaskCount() // 任务count
    try {
      this.baseInfo = this.$s.get('userInfo')
      this.companyList = this.$s.get('companyList')
      this.companyLength = (this.$s.get('companyList') || []).length
    } catch (error) {}
  },
  methods: {
    getAvatar,
    clickItem(name, type) {
      this.$router.push({ name, query: { type } })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    pendingTaskCount() {
      if (process.env.NODE_ENV !== 'development') {
        // 任务count
        const this_ = this
        // eslint-disable-next-line no-inner-declarations
        async function timerFn() {
          this_.add++
          const res = await getPendingTaskCount()
          if (res && res.code === 1) {
            // 第二次请求才提示任务完成
            if (this_.add > 1 && this_.count > res.data.count) {
              this_.$message({ type: 'success', message: this_.$t('payroll_salary_29') })
            }
            this_.count = res.data.count
          }
          this_.clearTime = setTimeout(timerFn, 5000)
        }
        timerFn()
      }
    },
    logout() {
      this.$util.messageBox(
        this.$t('301'),
        'warning',
        () => {
          utilCookies.removeToken()
          utilCookies.removeCompanyToken()
          window.location.reload()
        },
        () => {}
      )
    },
    // 公司登录
    handleCompanyLogin(item) {
      if (item.c_id === this.company_info.c_id) return
      this.loading = true
      const hash = window.location.hash
      const href = window.location.href
      const url = href.replace(hash, '#/dashboard')
      localStorage.removeItem('accessRecord')
      companyLogin({ c_id: item.c_id })
        .then(res => {
          // this.$ga.event('FHRSelectCompany', 'click', 'ScanQR', 18) // 登录公司埋点
          const { data } = res
          utilCookies.setCompanyToken(data.token)
          this.$s.set('currentCompany', data.info)
          this.$s.set('userInfo', data.info)
          window.location.href = url
          window.location.reload()
        })
        .finally(() => {
          this.loading = false
        })
    },
    loginCompany() {
      this.$router.push({
        path: '/login/create-company'
      })
    },
    onDownload() {
      // 异步下载列表
      this.$emit('onDownload')
    },
    changeLanguage(lang) {
      this.curLang = lang
      localStorage.setItem('language', lang.key)
    },
    // 模糊搜索公司
    handleQueryCompanyByName() {
      if (!this.companyName) {
        this.companyList = this.$s.get('companyList') || []
        return
      }
      const companyList = this.$s.get('companyList') || []
      this.companyList = companyList.filter(item => item.name.includes(this.companyName))
    }
  }
}
</script>
<style lang="scss">
.account-info-dropdown {
  min-width: 160px !important;
  overflow-x: hidden;
  .dropdown-list {
    line-height: 40px !important;
    padding: 0 15px;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .el-dropdown {
  font-size: 12px !important;
}
.picker {
  float: right;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 10px;
}
/deep/ .el-dialog__body {
  min-height: 100px;
}
.el-dropdown-link {
  color: $textColor !important;
}
.el-icon-arrow-down {
  margin-left: 10px;
}
.language-toggle-son {
  height: 100%;
  padding: 0 10px;
  img {
    width: 16px;
    vertical-align: middle;
    margin-right: 3px;
    margin-top: -3px;
  }
}
.count-item {
  cursor: pointer;
}
.count-item + .count-item {
  margin-top: 10px;
}
.el-radio-group {
  float: right;
  margin: 15px 20px 0 0;
}
.layout-navbar-popper {
  top: 30px !important;
}
.menu-item {
  font-size: 14px !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  i {
    font-size: 14px;
    line-height: 1;
  }
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: #e8f4ff !important;
    color: #7d74e1 !important;
    i {
      color: #7d74e1 !important;
    }
  }
  &.is-active {
    background-color: #5D51DA !important;
    color: #fff !important;
    i {
      color: #fff !important;
    }
  }
  .register {
    font-size: 12px;
    display: block;
    margin: 10px auto 0;
  }
  /deep/.el-submenu__title {
    width: 100%;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #909399 !important;
    i {
      color: #909399 !important;
      transform: rotate(90deg);
    }
    &:hover {
      background-color: #e8f4ff !important;
      color: #7d74e1 !important;
      i {
        color: #7d74e1 !important;
      }
    }
  }
}
.logo_url {
  height: 20px;
  margin-right: 8px;
}
.user {
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  dd {
    min-width: 100px;
    margin-left: 10px;
    line-height: 20px;
  }
  .company-name {
    background: #5D51DA;
    color: #fff;
    border-radius: 10px;
    padding: 0 5px;
  }
}
.menu-list {
  /deep/.el-menu--horizontal {
    max-height: 500px;
    overflow: hidden;
    top: 48px !important;
    overflow-y: auto;
  }
}
</style>
